import { render, staticRenderFns } from "./PopupWrapper.vue?vue&type=template&id=0cc274ca&scoped=true&lang=pug&"
import script from "./PopupWrapper.vue?vue&type=script&lang=js&"
export * from "./PopupWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc274ca",
  null
  
)

export default component.exports